<template lang="pug">
  .component-search-entity(@keydown="showChar", @keyup="showChar", tabindex="0")
    input.m-0(v-model="searchQuery", @input="debouncedSearch", type="text", @focusout="handleFocusout", @focusin="handleFocusIn", :placeholder="`Search ${entity}`" :class="{'noborder':showResults && !loading}")
    .loading(v-if="loading")
      loading-spinner(height="30px" )
    .results(v-if="!loading", :class="{'open': showResults, 'scroll': results.length > 6}", tabindex="1")
      .result(v-if="results.length && showResults" v-for="result in results", :key="result.id", :class="{'selected':result.id === selected}", @click="select($event, result)")
        slot(:result="result")
          div
            small {{prefix}}{{ result.id }}
            div {{ result.name }} {{ result.surname }}

      .no-results(v-if="!results.length && showResults" )
        .text-center No results

</template>
<script>

import LoadingSpinner from "../LoadingSpinner.vue";
import LoadingAnimation from "../../lib/LoadingAnimation.vue";
import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";

export default {
  name: "SearchEntity",
  components: {LoadingSpinner, LoadingAnimation},
  data() {

    return {
      searchQuery: '',
      results: [],
      debounceTimeout: null,
      loading: false,
      source: null,
      showResults: false,
      selected: null,
      selectedForNewTab: false,
      openInNewTab: false
    }
  },
  created() {

  },
  methods: {
    showChar(e) {
      this.openInNewTab = e.keyCode === 17 && e.ctrlKey
    },
    handleFocusIn() {
      if (this.loadedValues.length) {
        this.results = this.loadedValues
      }

      if (this.results.length) {
        this.showResults = true
      }

    },
    handleFocusout($evt) {
      if ($evt.relatedTarget !== null) {

        return
      }
      this.showResults = false
      this.loading = false
    },
    debouncedSearch() {
      if (this.loadedValues.length || this.searchQuery.length < 4) {
        this.loading = false
        return
      }
      clearTimeout(this.debounceTimeout);
      this.$emit('input', null)

      this.debounceTimeout = setTimeout(() => {
        if (this.source !== null) {
          this.source.cancel()
          this.results = []
          this.loading = false
          this.selected = null
          this.$emit('input', null)
        }

        this.source = KeplerBackofficeSdk.getSource()
        this.loading = true
        this.search()
      }, 300)
    },
    search() {
      try {
        this.selected = null

        if (this.searchQuery.length < 4) {
          return
        }
        KeplerBackofficeSdk[this.entity].list(1, -1, {query: this.searchQuery}).search((items) => {
          this.results = items.items
          this.loading = false
          this.showResults = true

        }, () => {
          this.loading = false
        }, this.source.token);
      } catch (error) {
        this.loading = false
      }
    },
    select($event, obj) {
      $event.preventDefault()
      this.searchQuery = `${this.prefix}${obj.id}`
      if (obj.name && obj.surname) {
        this.searchQuery += ` ${obj.name} ${obj.surname}`
      }
      this.selected = obj.id
      this.showResults = false

      if (this.results.length > 6) {

        const index = this.results.findIndex((item) => item.id === obj.id)
        if (index !== -1) {
          if (this.results.length === 0 || obj.id !== this.results[index].id !== obj.id) {
            this.results.splice(index, 1)

            this.results.unshift(obj)

          }
        }
      }

      if (this.openInNewTab) {
        const routeData = this.$router.resolve({name: this.entity.slice(0, -1), params: {id: obj.id}});
        window.open(routeData.href, '_blank');
        return
      }

      if (this.clearInput) {
        this.searchQuery = null
        this.results = []
      }

      this.$emit('input', obj.id)
      this.$emit('selected', obj.id)
    }
  },
  props: {
    value: {},
    clearInput: {
      type: Boolean,
      default: false
    },
    entity: {
      type: String,
      default: ""
    },
    loadedValues: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    prefix() {
      return this.entity.slice(0, 2).toUpperCase()
    }
  }
}
</script>

<style lang="sass">
.component-search-entity
  position: relative

  .spinner
    position: absolute
    top: 10px
    left: 50px


  .noborder
    border-bottom-right-radius: 0
    border-bottom-left-radius: 0
    border-bottom: none


  .results
    position: absolute
    background: white
    width: 100%
    top: 100%


    &.scroll
      max-height: 300px
      overflow-y: scroll

    &.open
      border-top: none
      border-left: 1px solid rgba(199, 199, 199, 0.67)
      border-right: 1px solid rgba(199, 199, 199, 0.67)
      border-bottom: 1px solid rgba(199, 199, 199, 0.67)
      display: inline-block
      position: relative

    .result
      padding: 0.5em
      border-radius: 2px
      cursor: pointer
      z-index: 9999

      &.selected
        background-color: #f4f8f8

    .no-results.results
      overflow-y: auto


</style>



// WEBPACK FOOTER //
// SearchEntity.vue?5c5e7300